module.exports = __webpack_public_path__ + "static/media/checked_radio.a67fa1a6.svg";